import { connectedAsUser, usersById, usersTypingByChannelId } from "../state";

export function flattenRawUser(rawUser) {
  const {
    id,
    name,
    online,
    firstName,
    company,
    avatar,
    title,
    location,
    type,
    role,
    pronouns,
    displayPronouns,
  } = rawUser;

  return {
    userId: id,
    name,
    firstName,
    company,
    avatar,
    title,
    location,
    role: type || role,
    isOnline: online,
    pronouns,
    displayPronouns,
  };
}

function hasUserChanged(oldUser, newUser) {
  return Object.keys(oldUser).some((prop) => oldUser[prop] !== newUser[prop]);
}

export function updateUser(flattenedUser) {
  const users = usersById.get();
  const found = users[flattenedUser.userId];
  if (!found || (found && hasUserChanged(found, flattenedUser))) {
    usersById.set({
      ...users,
      [flattenedUser.userId]: flattenedUser,
    });
  }
}

export function updateUsers(flattenedUsers) {
  const users = usersById.get();
  let hasUpdate = false;
  const updatedUsers = flattenedUsers.reduce((obj, flattenedUser) => {
    const found = users[flattenedUser.userId];
    if (!found || (found && hasUserChanged(found, flattenedUser))) {
      hasUpdate = true;
      obj[flattenedUser.userId] = flattenedUser;
    }
    return obj;
  }, {});
  if (hasUpdate) {
    usersById.set({ ...users, ...updatedUsers });
  }
}

export function upsertUserTypingByChannel(channelId, flattenedUser) {
  const { id: userId } = connectedAsUser.get();
  const usersTypingByChannel = usersTypingByChannelId.get();
  const currentTypingUsers = usersTypingByChannel[channelId] || [];
  const existingUser = currentTypingUsers.find(
    (u) => u.userId === flattenedUser.userId
  );

  if (!existingUser && userId !== flattenedUser.userId) {
    usersTypingByChannelId.set({
      ...usersTypingByChannel,
      [channelId]: [
        ...(usersTypingByChannel[channelId] || []),
        flattenedUser,
      ].sort((a, b) => a.name < b.name),
    });
  }
}

export function removeUserTypingByChannel(channelId, flattenedUser) {
  const usersByChannel = usersTypingByChannelId.get();
  const currentTypingUsers = usersByChannel[channelId] || [];
  const newUsers = currentTypingUsers.filter(
    (u) => u.userId !== flattenedUser.userId
  );

  usersTypingByChannelId.set({
    ...usersByChannel,
    [channelId]: newUsers,
  });
}
